import React from 'react';

export const AuthFormContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="flex justify-center min-h-[517px] md:min-h-[661px] mt-[22px] md:mt-0 flex md:items-center">
    <div className="bg-white dark:bg-[#1C1C1F] rounded-[42px] p-[22px] md:p-[32px] flex flex-col justify-center shadow-[0px_4px_10px_rgba(42,60,68,0.08)] dark:shadow-[0px_4px_10px_rgba(0,0,0,0.3)] border border-[#E5E5ED] dark:border-[#2E2E30] max-w-[345px] md:max-w-[456px]">
      {children}
    </div>
  </div>
);
